module.exports = __webpack_public_path__ + "img/expensesTypes.6e2b6b18.svg";